import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { MdClear } from 'react-icons/md';
import { debounce } from 'lodash';
import { makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import dayjs from 'dayjs';

import {
  Chat,
  confirmDialogStore,
  TICKET_CLOSE_STATUS,
} from '@qbot-chat/qbot-uikit';
import { COMMAND_EVENT_TYPE, CONTENT_TYPE } from '@qbot-chat/qbot-uikit/chat';

import { chatStore } from '../../../store/FrontChatStore';
import { navigateReplace } from '../../../helper/HistoryHelper';
import Styles from './ChatView.module.scss';

@observer
class ChatView extends Component {
  constructor(props) {
    super(props);
    makeObservable(this);
  }

  debounceRequest = debounce((store) => this.request(store), 200, {
    leading: true,
  });

  request = async (store) => {
    let contentType = CONTENT_TYPE.TEXT;
    let message = {
      content: {
        type: contentType,
        value: COMMAND_EVENT_TYPE.AGENT_CONNECT,
      },
      contentType,
      createdAt: dayjs(),
    };
    store.onSendMessage(message);
  };

  render() {
    return (
      <div className={`d-flex flex-default overflow-hidden`}>
        <Chat
          store={chatStore}
          isUser
          ref={chatStore.chatRef}
          renderCustomHeader={(store) => {
            return (
              <div className={Styles.HeaderContainer}>
                <div className={Styles.Header}>
                  <div>
                    {!store.isRespond && (
                      <div
                        className={Styles.CloseButton}
                        onClick={() => {
                          confirmDialogStore.open({
                            title: '종료',
                            summary: '상담을 종료하시겠습니까?',
                            onOk: () => {
                              store.close(store.channelId).then(() => {
                                navigateReplace(`/rating/${store.channelId}`);
                              });
                            },
                          });
                        }}
                      >
                        <MdClear size={24} />
                      </div>
                    )}
                  </div>
                  <div>
                    {!store.isRespond ? (
                      <>
                        {!TICKET_CLOSE_STATUS.includes(
                          store.channel?.status,
                        ) && (
                          <Button
                            variant={'outline-secondary'}
                            className={Styles.RequestButton}
                            style={{ whiteSpace: 'nowrap' }}
                            size={'sm'}
                            onClick={() => {
                              this.debounceRequest(store);
                            }}
                          >
                            상담사 연결
                          </Button>
                        )}
                      </>
                    ) : (
                      <Button
                        variant={'outline-danger'}
                        className={Styles.RequestButton}
                        style={{ whiteSpace: 'nowrap' }}
                        size={'sm'}
                        onClick={() => {
                          confirmDialogStore.open({
                            title: '종료',
                            summary: '상담을 종료하시겠습니까?',
                            onOk: () => {
                              store.close(store.channelId).then(() => {
                                navigateReplace(`/rating/${store.channelId}`);
                              });
                            },
                          });
                        }}
                      >
                        상담 종료
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            );
          }}
          onCloseCallback={() => {
            navigateReplace(`/rating/${chatStore.channelId}`);
          }}
        />
      </div>
    );
  }
}

export default ChatView;
